<template>
  <div class="search-page">
    <template v-if="keyword">
      <div class="search-total">关于 "{{ keyword }}" ，共找到{{ page.total || 0 }}个相关问题</div>
      <ul v-if="list.length" class="search-list">
        <li
          v-for="item in list"
          :key="item.id"
          class="search-item"
          @click="handleJump(item)"
        >
          <div class="search-item-title" v-html="item.title"></div>
          <div class="search-item-desc" v-html="item.content"></div>
        </li>
      </ul>
      <div v-else class="no-results">
        <van-empty description="很抱歉，暂时没有相关信息">
          <div slot="description" class="no-results-text">
            很抱歉，我们暂时无 "{{ keyword }}" 的相关信息，请您更换关键字后重新搜索。
          </div>
          <div class="no-results-links">
            您也可以前往
            <a class="link" href="https://bbs.aiservhub.com/" target="_blank">快应用论坛</a>
            <a class="link" href="https://doc.quickapp.cn/" target="_blank">快游戏开发文档</a>
            搜索相关内容
          </div>
        </van-empty>
      </div>
      <div class="pagination-wrap" v-if="page.total > page.pageSize">
        <van-pagination
          v-model="page.pageNo"
          :page-count="pageCount"
          mode="simple"
          @change="handlePageChange"
        />
      </div>
    </template>
    <div v-else class="empty-state">
      <van-empty description="请先输入您要查询的问题或关键字" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      keyword: '',
      list: [],
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },
  computed: {
    pageCount() {
      return Math.ceil(this.page.total / this.page.pageSize) || 1
    },
  },
  watch: {
    '$route.query': {
      handler() {
        this.keyword = this.$route.query.keyword || ''
        this.page.pageNo = 1
        this.handleSearch()
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleSearch() {
      if (!this.keyword) return
      this.$apis.gameProblemServer.search({
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        keyword: this.keyword,
      }).then(res => {
        if (res.code === 0) {
          this.list = res.data.dataList
          this.page.total = res.data.totalNum
        }
      })
    },
    handlePageChange() {
      this.handleSearch()
    },
    handleJump(item) {
      this.$router.push({ path: '/commonGameProblem/faqInfo', query: { id: item.id } })
    },
  },
}
</script>
<style lang="scss" scoped>
.search-page {
  background: #f5f7fb;
  min-height: 100%;
  padding: 24px;
}
.search-total {
  background: linear-gradient(135deg, #e8f0ff 0%, #f0f5ff 100%);
  color: #5a88ff;
  font-size: 26px;
  padding: 16px 32px;
  border-radius: 30px;
  margin-bottom: 24px;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(90,136,255,0.08);
}
.search-list {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
}
.search-item {
  padding: 28px 32px;
  border-bottom: 1px solid #f0f2f5;
  transition: background 0.2s;
  &:active {
    background: #f5f7fb;
  }
  &:last-child {
    border-bottom: none;
  }
  &-title {
    font-size: 30px;
    font-weight: 600;
    color: #333;
    line-height: 1.5;
    margin-bottom: 12px;
  }
  &-desc {
    font-size: 26px;
    color: #999;
    line-height: 1.6;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
.no-results {
  background: #fff;
  border-radius: 16px;
  padding: 60px 32px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  &-text {
    font-size: 28px;
    color: #666;
    line-height: 1.6;
  }
  &-links {
    font-size: 28px;
    color: #666;
    margin-top: 20px;
    .link {
      color: #5a88ff;
      margin: 0 10px;
      font-weight: 500;
    }
  }
}
.pagination-wrap {
  margin-top: 24px;
  display: flex;
  justify-content: center;
  /deep/ .van-pagination {
    font-size: 26px;
    .van-pagination__item {
      min-width: 56px;
      height: 56px;
    }
    .van-pagination__item--active {
      background: #5A88FF;
      border-color: #5A88FF;
    }
  }
}
.empty-state {
  padding-top: 160px;
}
</style>
